skrilla.controller('createMatchPlaceholdersCtrl', function ($scope, searchService, srefService, cacheService, modalService, $stateParams) {
    $scope.sport = $stateParams.sport;
    cacheService.registerObject("contestSport", $scope.sport);
    $scope.types = [
        "QUARTER_FINAL",
        "SEMI_FINAL",
        "GRAND_FINAL",
        "DEFAULT"
    ];

    $scope.save = function(){
        modalService.confirm("Are you sure you'd like to create this placeholder?", function(){
            $scope.placeholder.sportType = $scope.sport
            if($scope.placeholder.match1){
                $scope.placeholder.originMatch1Id = $scope.placeholder.match1.id;
            }
            if($scope.placeholder.match2){
                $scope.placeholder.originMatch2Id = $scope.placeholder.match2.id;
            }
            if($scope.placeholder.placeholder1){
                $scope.placeholder.originPlaceholder1Id = $scope.placeholder.placeholder1.id;
            }
            if($scope.placeholder.placeholder2){
                $scope.placeholder.originPlaceholder2Id = $scope.placeholder.placeholder2.id;
            }
            searchService.post($scope.sport + "/matches/placeholders", $scope.placeholder, "Placeholder successfully created!").then(function(response){
                srefService.go("matchPlaceholders", {});
            });
        });
    }

    $scope.selectMatch = function(match){
        cacheService.registerObject("matchesModalFunction", function(season, _match){
            cacheService.registerObject("selectedMatch", _match);
            modalService.dismissAll();
        }, true);
        modalService.openModal('/views/matchesModal/matchesModal.html', true, 'lg', true, true, function(){
            $scope.placeholder[match] = cacheService.getObject("selectedMatch");
        });

    }

    $scope.selectPlaceholder = function(placeholder){
        cacheService.registerObject("matchPlaceholdersFunction", function(_placeholder){
            cacheService.registerObject("selectedMatchPlaceholder", _placeholder);
            modalService.dismissAll();
        }, true);
        modalService.openModal('/views/matchPlaceholders/matchPlaceholdersModal.html', true, 'lg', true, true, function(){
            $scope.placeholder[placeholder] = cacheService.getObject("selectedMatchPlaceholder");
            console.log($scope.placeholder[placeholder]);
        });
    }

    $scope.getMatchTitle = function(match){
        if(match){
            return match.homeFranchise.name + " v " + match.awayFranchise.name;
        }
        else{
            return "Select Match"
        }
    }

});